import { Grid } from "@mui/material";
import { minLength, NumberInput, ReferenceArrayInput, required, SelectArrayInput } from "react-admin";
import CustomDateInput from "server/components/Fields/CustomDateInput";
import { useWatch } from "react-hook-form";
import { specialistRequests } from "api/specialistApi";

const SaveForm = () => {
  const coursesYear = useWatch({ name: "coursesYear" });
  const validYear = String(coursesYear ?? "").length >= 4 ? coursesYear : null;

  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        xs={12}
        md={3}
      >
        <NumberInput
          source="coursesYear"
          label="Година"
          validate={[required(), minLength(4)]}
        />
      </Grid>
      {validYear && (
        <Grid
          item
          xs={12}
          md={3}
        >
          <ReferenceArrayInput
            source="courseIds"
            reference={specialistRequests.getHealthcareCoursesByYear(coursesYear)}
          >
            <SelectArrayInput
              optionText="nameBg"
              label="Курсове"
              validate={required()}
            />
          </ReferenceArrayInput>
        </Grid>
      )}
      <Grid
        item
        xs={12}
        md={3}
      >
        <CustomDateInput
          source="applicationStartTimestamp"
          label="Начало на кампания"
          validate={required()}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={3}
      >
        <CustomDateInput
          source="applicationEndTimestamp"
          label="Край на кампания"
          validate={required()}
        />
      </Grid>
    </Grid>
  );
};

export default SaveForm;
